export default "__VITE_ASSET__BP4qnp6f__"